import { asUTC, dateFormatter } from "@validereinc/utilities";
import classNames from "classnames/bind";
import format from "date-fns/format";
import isValid from "date-fns/isValid";
import parse from "date-fns/parse";
import parseISO from "date-fns/parseISO";
import React from "react";
import { Icon } from "../../Icon";
import { colours } from "../../constants/colours";
import { DataDisplayWithAdornment } from "../_components/DataDisplayWithAdornment";
import styles from "./DateDataDisplay.module.scss";
import type { DateDataDisplayProps } from "./types";

const cx = classNames.bind(styles);

const DateDataDisplay = ({
  value,
  parseFormat,
  displayFormat,
  convertToUTC = false,
  referenceDate,
  alignment = "left",
  emptyText = "-",
  showInvalidIndicator = true,
  invalidText = "Unsupported data type",
  className,
  style,
  isInline = false,
  isBusy = false,
  isLoading = false,
  as = "p",
}: DateDataDisplayProps) => {
  const trueValue =
    value instanceof Date || typeof value === "string"
      ? value instanceof Date
        ? value
        : typeof value === "string"
          ? parseFormat
            ? parse(value, parseFormat, referenceDate ?? new Date())
            : parseISO(value)
          : null
      : null;
  const isEmpty = value === null || value === "" || value === undefined;
  const isInvalid = trueValue === null || !isValid(trueValue);

  return (
    <DataDisplayWithAdornment
      showAdornment={showInvalidIndicator && !isEmpty && isInvalid}
      alignment={alignment}
      isInline={isInline}
      isBusy={isBusy}
      isLoading={isLoading}
      adornmentSlot={({ iconProps, className }) => (
        <span className={className}>
          <Icon
            {...iconProps}
            variant="warning"
            colour={colours.status.warning}
            alt={invalidText}
            aria-roledescription="Warning Icon"
          />
        </span>
      )}
      className={cx("container", className, isInvalid && "bare")}
      style={style}
      as={as}
    >
      {isEmpty || isInvalid ? (
        emptyText
      ) : (
        <>
          {displayFormat
            ? format(convertToUTC ? asUTC(trueValue) : trueValue, displayFormat)
            : dateFormatter(trueValue, convertToUTC)}
        </>
      )}
    </DataDisplayWithAdornment>
  );
};

export default DateDataDisplay;
